import { styled } from '@mui/material/styles';

import ListItem from '@mui/material/ListItem';

const EventCardWrapper = styled(ListItem)`
  justify-content: center;
  padding: 8px 0;
`;

export default EventCardWrapper;